import { TDateISO } from '../../interfaces/templates/date';
import { SettingsType } from './settings-type';

export declare class SettingsEntity {
  public readOnly: boolean;
  public type: SettingsType;
  public value: string;
}
